import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import apiService from './service/api.service';
import tokenService from './service/token.service';
import SessionService from './service/session';
import { appConfig } from './config/appConfig';
import NavRouter from './route/router.js';
import Loader from './component/Loader/Loader';
import { isErrorExist, isOnlyAlphaAndNumericValid, objectIsEmpty } from './utils/validAndTest';

function App() {
  //conditioinal rendering or redirect to URL
  const [mount, setMount] = useState(false);
  const [tokenGenerated, setTokenGenerated] = useState(false)
  const {t} = useTranslation();

  const handleUserInfo = () => {

    const body = {
      access_token: SessionService.accessTokenWithoutBearer(),
      id_token: SessionService.idToken(),
      client_id: tokenService.getFromMobile()?appConfig.CLIENT_ID_MOBILE:appConfig.CLIENT_ID_WEB,
    };

    let jwtToken = body.id_token;
    if (jwtToken) {
      const identities =  tokenService.extractIdentitiesFromJwt(jwtToken);
      if (identities) {
        body.identities = identities;
      }
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    };

    if (SessionService.isError() && SessionService.isError() !== null) { return }

    const url = `${appConfig.RESTPOINT_URL}/api/rest/restpoints/community_hub/validate`;

    fetch(url, requestOptions)
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        if (isErrorExist(response?.status)) {
          tokenService.setErrorData(true);
          setMount(true);
        }
      })
      .then(data => {
        let fieldErrorData = {};
        let shouldRedirect = true;

        if (data?.isRecord === true || data?.isRecord === false) {
          if (isOnlyAlphaAndNumericValid(data?.firstName) === false) {
            fieldErrorData.firstName = 'TEXT_FORM_FIELD_NAME_NOT_VALID';
          }

          if (isOnlyAlphaAndNumericValid(data?.lastName) === false) {
            fieldErrorData.lastName = 'TEXT_FORM_FIELD_NAME_NOT_VALID';
          }

          if(data?.isPrivateMail){
            fieldErrorData.email = 'TEXT_FORM_FIELD_EMAIL_IS_PRIVATE';
          }

          if (!objectIsEmpty(fieldErrorData) || SessionService.isState()) {
            setMount(true);
            tokenService.removeErrorData();
            sessionStorage.setItem('userInfo', JSON.stringify(data));
            shouldRedirect = false;
          } else {
            setMount(false);
            shouldRedirect = (data?.isRecord === true); // Redirect only if isRecord is true
            if (!shouldRedirect) {
              let isFormSubmission = false;
              apiService.validateUserData(data, isFormSubmission);
            }
          }
        }
        if (shouldRedirect) {
          if (SessionService.isError() && SessionService.isError() !== null) { return }
          apiService.validateUrl();
        }
      })
      .catch(error => {
        console.log('err', error);
        // Handle any errors here
      });
  }

  useEffect(() => {
    if(tokenService.getUser()){
      if (SessionService.idToken()) {
        setTokenGenerated(true);
        handleUserInfo();
      }
    }
  }, []);

  useEffect(() => {
    if (SessionService.isError() && SessionService.isError() !== null) {
      setMount(true);
    }
  }, [SessionService.isError()]);

  return (
    {tokenGenerated} && <div className="App">
      {(mount && tokenService.getUserInfo() !== null) || (mount && SessionService.isError()) ? <NavRouter navigationCase={SessionService.isError()} /> : null}
      {!mount ? <Loader /> : null}
    </div>
  );
}

export default App;
